"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLabRequisitionListItem = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const utils_1 = require("../utils");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
const LabRequisitionContext_1 = require("../context/LabRequisitionContext");
const useLabRequisitionListItem = (requisition) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const labRequisitionContext = (0, react_1.useContext)(LabRequisitionContext_1.LabRequisitionContext);
    const [localIsExpanded, setLocalIsExpanded] = (0, react_1.useState)(false);
    // Use context-based expansion state if available, otherwise use local state
    const isExpanded = labRequisitionContext
        ? labRequisitionContext.expandedRequisitionId === requisition.id
        : localIsExpanded;
    const requisitionPanels = requisition.tests.map(p => p.name).join(", ");
    const readableCollectionDate = (0, utils_1.convertDateFormat)(requisition.specimenInformation.collectionDate, "MMM D, YYYY");
    const fetchOrders = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext) => __awaiter(void 0, void 0, void 0, function* () {
        if (!!selectedOrgUser) {
            yield selectedOrgUser.labsManager.getLabRequisitionOrders(requisition.id, abortContext);
        }
    }), utils_1.Constants.API_DEBOUNCE_DELAY_IN_MS);
    const toggleExpand = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isExpanded) {
            yield fetchOrders();
        }
        if (labRequisitionContext) {
            // Use context-based state
            if (labRequisitionContext.expandedRequisitionId === requisition.id) {
                labRequisitionContext.setExpandedRequisitionId(null);
            }
            else {
                labRequisitionContext.setExpandedRequisitionId(requisition.id);
            }
        }
        else {
            // Fallback to local state
            setLocalIsExpanded(!localIsExpanded);
        }
    });
    return {
        toggleExpand,
        isExpanded,
        requisitionPanels,
        readableCollectionDate,
    };
};
exports.useLabRequisitionListItem = useLabRequisitionListItem;
